var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Box } from "@mui/material";
import React from "react";
import { ReactComponent as CloseIcon } from "../../../../assets/images/closeIcon.svg";
import { useNavigate } from "react-router-dom";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../../assets/customIcons";
import { EditIcon } from "../../../fieldFailureReports/assets/svg";
import { DynamicFormBuilderContainer } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { AdditionalInfo } from "../../../fieldFailureReports/components/fieldFailureReportDetailsView/AdditionalInfo";
import { FieldFailureReportsKeys } from "../../../fieldFailureReports/services/entity";
import { ChecklistView } from "../../../fieldFailureReports/components/fieldFailureReportDetailsView/ChecklistView";
import { customerDetailsView, vehicalDetails } from "../../../fieldFailureReports/components/fieldFailureReportCreateForm/BasicDetailsAndVehicleDetails";
import { ProductRepairAndCustomerDetails } from "../AFRs/components/ViewComponent/generalTAB";
import { HistoryTab } from "./components/HistoryTab";
import { ChildFF } from "./components/ChildFFR";
import { PhysicalPhenamena } from "../../../fieldFailureReports/components/fieldFailureReportDetailsView/PhysicalPhenamena";
import { FieldFailureReportsGetAPI } from "../../services/apiCalls";
var FFRReportDetailsView = function (_ref) {
    var onClose = _ref.onClose, data = _ref.data;
    var navigate = useNavigate();
    var GeneralViewSection = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    columnSize: true,
                    elements: __spreadArray([{
                            type: FormItemTypes.Typography,
                            name: "title",
                            fontSize: "md",
                            fontWeight: "strong",
                            children: "Basic Details",
                            columnSize: 12,
                            sx: {
                                p: 0,
                                m: 0
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: true,
                            elements: __spreadArray([], customerDetailsView, true)
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: true,
                            elements: __spreadArray([], vehicalDetails, true)
                        }], ProductRepairAndCustomerDetails, true)
                }]
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "supplier",
            columnSize: 12,
            mt: 3,
            bgcolor: "overlay.white",
            flexDirection: "row",
            justifyContent: "space-between",
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: "",
                    columnSize: data.Status === 'Open' ? 7 : 9,
                    display: "flex",
                    spacing: 0,
                    pl: 2,
                    item: false,
                    elements: [{
                            type: FormItemTypes.Box,
                            name: "",
                            display: "flex",
                            flexDirection: "row",
                            mt: 1,
                            columnSize: 11,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "DocumentName",
                                    valueGetter: function (state) { return "Details - ".concat(state.DocumentName); },
                                    fontWeight: "strong",
                                    fontSize: "xl",
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Chip,
                                    name: "Status",
                                    value: function (state) { return state.Status; },
                                    columnSize: 0,
                                    color: "info",
                                    sx: {
                                        ml: 1,
                                        mt: 0.5,
                                        borderRadius: 1
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    spacing: 1,
                    alignItems: "center",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary"
                        }, (data === null || data === void 0 ? void 0 : data.Status) === 'Open' ? {
                            type: FormItemTypes.Button,
                            name: '',
                            columnSize: 0,
                            startIcon: /*#__PURE__*/ React.createElement(EditIcon, null),
                            variant: "outlined",
                            color: 'primary',
                            children: "Edit",
                            onClick: function () {
                                if (data !== null && data !== void 0 && data.id) {
                                    navigate("/fieldFailureReports/ffr/".concat(data === null || data === void 0 ? void 0 : data.id));
                                    onClose();
                                }
                            }
                        } : null, {
                            type: FormItemTypes.IconButton,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                color: "text.secondary",
                                height: "12px",
                                width: "12px"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose(false);
                            },
                            sx: {
                            // padding: '12px'
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.Divider,
            name: "",
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: "",
            sx: {
                pt: 0
            },
            columnSize: true,
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: "Stepper",
                    label: "",
                    value: null,
                    tabs: [{
                            id: "0",
                            label: "General",
                            elements: GeneralViewSection
                        }, {
                            id: "1",
                            label: "Physical Phenamena",
                            elements: PhysicalPhenamena
                        }, {
                            id: "2",
                            label: "Additional info",
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: "table",
                                    columnSize: 12,
                                    spacing: 0,
                                    elements: AdditionalInfo
                                }]
                        }, {
                            id: "3",
                            label: "Checklist",
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: "table",
                                    columnSize: 12,
                                    spacing: 0,
                                    elements: ChecklistView
                                }]
                        }, {
                            id: "4",
                            label: "History",
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "table",
                                    columnSize: 12,
                                    spacing: 0,
                                    element: HistoryTab
                                }]
                        }, {
                            id: "5",
                            label: "ChildFFR",
                            elements: [{
                                    type: FormItemTypes.Custom,
                                    name: "table",
                                    columnSize: 12,
                                    spacing: 0,
                                    element: ChildFF
                                }]
                        }],
                    valueExpr: "id",
                    displayExpr: "label",
                    columnSize: 12,
                    variant: "scrollable"
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        p: 2,
        sx: {
            paddingTop: {
                md: "60px",
                lg: "60px"
            }
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        gridProps: {
            spacing: 0,
            gap: "20px"
        },
        formData: formData,
        getFormAPI: FieldFailureReportsGetAPI,
        getKey: FieldFailureReportsKeys.create,
        getRequest: {
            id: data === null || data === void 0 ? void 0 : data.id
        }
    })));
};
export default FFRReportDetailsView;
